import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeTh from '@angular/common/locales/th';
import localeZh from '@angular/common/locales/zh';
import { TranslateLoader, TranslateService, TranslationObject } from '@ngx-translate/core';
import { Observable, switchMap, throwError } from 'rxjs';
import translationMetadata from 'src/app/generated/translation.json';
import { TRANSLATION_CACHE_BUSTING } from 'src/app/generated/config';
import { SessionService } from './session/session.service';

registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeEnGB);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeIt);
registerLocaleData(localeJa);
registerLocaleData(localeKo);
registerLocaleData(localeZh);
registerLocaleData(localePt);
registerLocaleData(localePl);
registerLocaleData(localeNl);
registerLocaleData(localeCs);
registerLocaleData(localeTh);
registerLocaleData(localeRu);
registerLocaleData(localeHu, 'hu');
registerLocaleData(localeRo, 'ro');

export function initLocale(
  translateService: TranslateService,
  sessionService: SessionService,
): Observable<unknown> {
  return sessionService.getSessionChangedSubscription().pipe(
    switchMap((session) => {
      const languages = Object.keys(translationMetadata.fileHashes);
      translateService.addLangs(languages);
      const userLocale = session.locale;
      const userLanguage = userLocale.replace(/-.*/, '');
      for (const language of [userLocale, userLanguage, 'en']) {
        if (languages.includes(language)) {
          return translateService.use(language);
        }
      }
      return throwError(() => new Error('Could not find any language'));
    })
  );
}

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new MappedTranslateLoader(http);
}

class MappedTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly prefix: string = '/assets/i18n/',
    private readonly suffix: string = '.json'
  ) {}

  public getTranslation(locale: string): Observable<TranslationObject> {
    let basename = locale;
    if (TRANSLATION_CACHE_BUSTING) {
      if (!(locale in translationMetadata.fileHashes)) {
        throw new Error(`No translation file found for locale: ${locale}`);
      }
      const hash = translationMetadata.fileHashes[locale as keyof typeof translationMetadata.fileHashes];
      basename = `${locale}.${hash}`;
    }
    return this.http.get<TranslationObject>(`${this.prefix}${basename}${this.suffix}`);
  }
}
